import script from "./CustomerForecastTableCellWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerForecastTableCellWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerForecastTableCellWrapper.vue?vue&type=style&index=0&id=36efe1ad&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36efe1ad"]])

export default __exports__